import React from 'react';

import imgWelcome from './../../../../images/onboardingTour/onboarding-welcome.png';
import imgNavigation from './../../../../images/onboardingTour/onboarding_navigation.gif';
import imgFilters from './../../../../images/onboardingTour/onboarding-filters.gif';
import imgEventList from './../../../../images/onboardingTour/onboarding-event-list.gif';
import imgFinished from './../../../../images/onboardingTour/onboarding-finished.png';
import { useTranslation } from 'react-i18next';
import OrganizationModel from '../../../../models/organization';
import useAppContext from '../../../../context/useAppContext';
import moment from 'moment-timezone';
import { usePermissions } from '../../../../user/permissions';
import OnboardingModalTour from '../../../../components/onboarding-tour/onboardingModalTour';

export default function OnboardingEventList({ viewType = 'desktop' }) {
    const { t } = useTranslation();
    const permissions = usePermissions();
    const [{ organization }, setContext] = useAppContext();

    const isMobile = React.useMemo(() => {
        return ['mobile', 'tablet'].includes(viewType);
    }, [viewType]);

    const handleSubmitOnboardingFinished = React.useCallback(() => {
        const updated_orga = new OrganizationModel({ id: organization.pk, onboarding_tour_date: moment().toISOString() });
        updated_orga
            .save({})
            .then(() => {
                //Update orga in context so as not to re-trigger an unnecessary reload
                organization.onboarding_tour_date = updated_orga.onboarding_tour_date;
                setContext({ organization });
                console.info('onboarding-tour-finished');
            })
            .catch(e => {
                console.error(e);
            });
    }, [setContext, organization]);

    const _onFinished = React.useCallback(() => {
        handleSubmitOnboardingFinished();
    }, [handleSubmitOnboardingFinished]);

    let steps = React.useMemo(() => {
        return [
            {
                stepName: 'welcome',
                title: t('ticket.onboardingTour.eventList.stepWelcome.title'),
                subtitle: t('ticket.onboardingTour.eventList.stepWelcome.subtitle'),
                imgSrc: imgWelcome
            },
            {
                stepName: 'navigation',
                title: t('ticket.onboardingTour.eventList.stepNavigation.title'),
                subtitle: t('ticket.onboardingTour.eventList.stepNavigation.content'),
                imgSrc: imgNavigation,
                href: 'https://www.google.fr'
            },
            {
                stepName: 'filters',
                title: t('ticket.onboardingTour.eventList.stepFilters.title'),
                subtitle: t('ticket.onboardingTour.eventList.stepFilters.content'),
                imgSrc: imgFilters,
                href: 'https://www.google.fr'
            },
            {
                stepName: 'event',
                title: t('ticket.onboardingTour.eventList.stepEvent.title'),
                subtitle: t('ticket.onboardingTour.eventList.stepEvent.content'),
                imgSrc: imgEventList,
                href: 'https://www.google.fr'
            },
            {
                stepName: 'finished',
                title: t('ticket.onboardingTour.eventList.stepFinished.title'),
                subtitle: t('ticket.onboardingTour.eventList.stepFinished.content'),
                imgSrc: imgFinished,
                href: 'https://www.google.fr'
            }
        ];
    }, []);

    const triggerOnboardingTour = React.useMemo(() => {
        //Do not display for Admin
        if (permissions.isAdmin()) {
            return false;
        }

        //Onboarding already completed
        if (organization.onboarding_tour_date) {
            return false;
        }

        return permissions.capacities.has('PyvarCapacity.SWITCH_ONBOARDING');
    }, [organization, permissions]);

    if (!triggerOnboardingTour) {
        return null;
    }

    return (
        <>
            {triggerOnboardingTour && (
                <OnboardingModalTour
                    onFinished={_onFinished}
                    isMobile={isMobile}
                    steps={steps}
                    labelCTAProps={{
                        start: null,
                        next: t('ticket.common.action.next'),
                        back: null,
                        last: t('ticket.common.action.finish'),
                        findOutMore: t('ticket.common.cta.findOutMore')
                    }}
                />
            )}
        </>
    );
}
